<script setup>
import HomePage from '~/components/home/HomePage.vue'
</script>

<template>
  <HomePage />
</template>
